import globals from '../globals';
export default {
    data() {
        return {
            warning_msg: "",
        }
    },
    components: {
        globals,
    },
    methods: {
        async getUserPermittedCheckbox() {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/user_permissions/actions/all`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getUserRoles(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post(globals.AUTH_SERVICE + "/products/product_role/list", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getUserPermissionsSalesManager(id) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.CRM_SALES_URL + "/user_permissions/" + id);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getUserPermissions(id) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/user_permissions/${id}?operation=actions`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async editUserPermissions(id, params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/user_permissions/" + id, params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch (err) {
                    this.warning_msg = err.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                        this.loadModules()
                    }, 3000);
                }
            })
        },
        async getUserPermissionsModules(id, module_name) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/user_permissions/modules/${id}?module_name=${module_name}`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getModulePermitted(id, module_name) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/user_permissions/modules/permitted/${id}?module_name=${module_name}`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getUserPermissionsActions(id, sub_module) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/user_permissions/actions/${id}?sub_module=${sub_module}`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /*SubModules User permission API Integration */
        async permittedModules(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.CRM_SALES_URL + "/user_permissions/modules/permitted/" + `${params.id}?module_name=${params.module_name}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        // this.warning_msg = response.data.reason
                        // this.$refs.warning_modal.open();
                        // setTimeout(() => {
                        //     this.$refs.warning_modal.close();
                        // }, 3000);
                    }
                } catch (error) {
                    this.warning_msg = sessionStorage.getItem("error")
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/user_permission.js